const useCitizenAnswer = () => {
  const needValidateCode = answer =>
    answer.email_phone_applicant_response && !answer?.disable_confirmation && isProcedure(answer)

  const isProcedure = answer => answer.form.procedure_management_id !== null

  return { needValidateCode, isProcedure }
}

export default useCitizenAnswer
